import { loadStripe } from '@stripe/stripe-js';

export function getStripeClient({ apiKey }: { apiKey: string }) {
  return loadStripe(apiKey);
}
